export default __webpack_public_path__ + "static/media/Test_Booking_UploadFile_Template.86b9c5c5.xlsx";